import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { LoggerEventsEnum } from '../../enums/logger-events.enum';
import { PushNotifications } from '../../models/PushNotifications';
import { LoggerService } from '../logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class PwaProcessService {
  public promptEvent: any;
  private _shouldInstall$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _appInstalled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _startInstall$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private _installResult$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  public get shouldInstall$(): Observable<boolean> {
    return this._shouldInstall$.asObservable();
  }

  public get appInstalled$(): Observable<boolean> {
    return this._appInstalled$.asObservable();
  }

  public get startInstall$(): Observable<boolean> {
    return this._startInstall$.asObservable();
  }

  public get installResult$(): Observable<string> {
    return this._installResult$.asObservable();
  }

  constructor(
    private logger: LoggerService,
    private pushNotifications: PushNotifications
  ) {
    this.setListeners();
  }

  private setListeners() {
    fromEvent(window, 'beforeinstallprompt').subscribe((e: Event) => {
      e.preventDefault();
      this.promptEvent = e;
      const condition = !!(!this.isRunningStandalone() && this.promptEvent);
      this._shouldInstall$.next(condition);
    });

    fromEvent(window, 'appinstalled').subscribe(async (e: Event) => {
      this.logger.sendFetchEvent(LoggerEventsEnum.INSTALL);
      e.preventDefault();
      if ('getInstalledRelatedApps' in window.navigator) {
        const interval = setInterval(async () => {
          const installedApps = await (navigator as any)?.getInstalledRelatedApps();
          if (installedApps.length > 0) {
            setTimeout(async () => {
              this._appInstalled$.next(true);
            }, 3000);

            clearInterval(interval);
          }
        }, 500);
      }

      this._startInstall$.next(true);
      this.promptEvent = null;

      setTimeout(async () => {
        // this.logger.sendFetchEvent(LoggerEventsEnum.PUSH_SUBSCRIPTION);
        await this.pushNotifications.requestPermissions();
      }, 1000);
    });
  }

  async installApp(): Promise<void> {
    if (this.promptEvent) {
      this._installResult$.next('started');
      const result = await this.promptEvent.prompt();
      this._installResult$.next(result.outcome);
      this.promptEvent = null;
      this._shouldInstall$.next(false);
    }
  }

  private isRunningStandalone(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches;
  }
}
